import config from './config'

export const isScene = (shape: string) => {
  return shape === config.nodeTypes.scene
}

export const isEdge = (shape: string) => {
  return shape === config.nodeTypes.edge
}

/**
 * 是否是场景节点的子节点
 */
export const isNode = (shape: string) => {
  return shape === config.nodeTypes.node
}

